import { Typography } from '@mui/material';

import { MediaUpload, RHFTextField } from 'components';
import { useInspectionPath } from 'hooks';
import { useInspectionSelector } from 'stores';

import { GridWrap, TitleSection } from './Accordion11CommentiPerReport.styles';

const Accordion11CommentiPerReport = () => {
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();
  return (
    <>
      <GridWrap container spacing={2} padding="20px">
        <GridWrap marginBottom={-25} marginTop={16} item xs={12}>
          <TitleSection>
            <Typography variant="h3BoldBlue">
              {"DESCRIZIONE DELL'OPERA"}
            </Typography>
          </TitleSection>
        </GridWrap>
        <GridWrap item xs={12}>
          <RHFTextField
            multiline
            name="descrizioneOpera"
            label={'Descrizione'}
            inputProps={{ maxLength: 2000 }}
            disabled={inspectionDisabled || isViewingInspection}
            defaultValue=""
          />
        </GridWrap>
        <GridWrap item md={3}>
          <MediaUpload
            title={`Immagini`}
            btnTitle="Seleziona"
            preview={true}
            formName="fotoDescrizioneOpera"
            infoPanel="Seleziona le foto tra quelle già caricate per l'ispezione, è necessario salvare l'ispezione per visualizzare le ultime immagini caricate"
            onlySelection={true}
          />
        </GridWrap>
      </GridWrap>

      <GridWrap container spacing={2} padding="20px">
        <GridWrap marginBottom={-25} marginTop={16} item xs={12}>
          <TitleSection>
            <Typography variant="h3BoldBlue">
              {'CONTESTO AMBIENTALE'}
            </Typography>
          </TitleSection>
        </GridWrap>
        <GridWrap item xs={12}>
          <RHFTextField
            multiline
            name="descrizioneContestoAmbientale"
            label={'Descrizione'}
            inputProps={{ maxLength: 2000 }}
            disabled={inspectionDisabled || isViewingInspection}
            defaultValue=""
          />
        </GridWrap>
        <GridWrap item md={3}>
          <MediaUpload
            title={`Immagini`}
            btnTitle="Seleziona"
            preview={true}
            formName="fotoContestoAmbientale"
            infoPanel="Seleziona le foto tra quelle già caricate per l'ispezione, è necessario salvare l'ispezione per visualizzare le ultime immagini caricate"
            onlySelection={true}
          />
        </GridWrap>
      </GridWrap>
      <GridWrap container spacing={2} padding="20px">
        <GridWrap marginBottom={-25} marginTop={16} item xs={12}>
          <TitleSection>
            <Typography variant="h3BoldBlue">{'RISCHIO FRANE'}</Typography>
          </TitleSection>
        </GridWrap>
        <GridWrap item xs={12}>
          <RHFTextField
            multiline
            name="descrizioneRischioFrane"
            label={'Descrizione'}
            inputProps={{ maxLength: 2000 }}
            disabled={inspectionDisabled || isViewingInspection}
            defaultValue=""
          />
        </GridWrap>
        <GridWrap item md={3}>
          <MediaUpload
            title={`Immagini`}
            btnTitle="Seleziona"
            preview={true}
            formName="fotoRischioFrane"
            infoPanel="Seleziona le foto tra quelle già caricate per l'ispezione, è necessario salvare l'ispezione per visualizzare le ultime immagini caricate"
            onlySelection={true}
          />
        </GridWrap>
      </GridWrap>
      <GridWrap container spacing={2} padding="20px">
        <GridWrap marginBottom={-25} marginTop={16} item xs={12}>
          <TitleSection>
            <Typography variant="h3BoldBlue">{'RISCHIO IDRAULICO'}</Typography>
          </TitleSection>
        </GridWrap>
        <GridWrap item xs={12}>
          <RHFTextField
            multiline
            name="descrizioneRischioIdraulico"
            label={'Descrizione'}
            inputProps={{ maxLength: 2000 }}
            disabled={inspectionDisabled || isViewingInspection}
            defaultValue=""
          />
        </GridWrap>
        <GridWrap item md={3}>
          <MediaUpload
            title={`Immagini`}
            btnTitle="Seleziona"
            preview={true}
            formName="fotoRischioIdraulico"
            infoPanel="Seleziona le foto tra quelle già caricate per l'ispezione, è necessario salvare l'ispezione per visualizzare le ultime immagini caricate"
            onlySelection={true}
          />
        </GridWrap>
      </GridWrap>
      <GridWrap container spacing={2} padding="20px">
        <GridWrap marginBottom={-25} marginTop={16} item xs={12}>
          <TitleSection>
            <Typography variant="h3BoldBlue">{'DOCUMENTAZIONE'}</Typography>
          </TitleSection>
        </GridWrap>
        <GridWrap item xs={12}>
          <RHFTextField
            multiline
            name="descrizioneDocumentazione"
            label={'Descrizione'}
            inputProps={{ maxLength: 2000 }}
            disabled={inspectionDisabled || isViewingInspection}
            defaultValue=""
          />
        </GridWrap>
        <GridWrap item md={3}>
          <MediaUpload
            title={`Immagini`}
            btnTitle="Seleziona"
            preview={true}
            formName="fotoDocumentazione"
            infoPanel="Seleziona le foto tra quelle già caricate per l'ispezione, è necessario salvare l'ispezione per visualizzare le ultime immagini caricate"
            onlySelection={true}
          />
        </GridWrap>
      </GridWrap>

      <GridWrap container spacing={2} padding="20px">
        <GridWrap marginBottom={-25} marginTop={16} item xs={12}>
          <TitleSection>
            <Typography variant="h3BoldBlue">{'ATTIVITÀ PREGRESSE'}</Typography>
          </TitleSection>
        </GridWrap>
        <GridWrap item xs={12}>
          <RHFTextField
            multiline
            name="descrizioneAttivitaPregresse"
            label={'Descrizione'}
            inputProps={{ maxLength: 2000 }}
            disabled={inspectionDisabled || isViewingInspection}
            defaultValue=""
          />
        </GridWrap>
        <GridWrap item md={3}>
          <MediaUpload
            title={`Immagini`}
            btnTitle="Seleziona"
            preview={true}
            formName="fotoAttivitaPregresse"
            infoPanel="Seleziona le foto tra quelle già caricate per l'ispezione, è necessario salvare l'ispezione per visualizzare le ultime immagini caricate"
            onlySelection={true}
          />
        </GridWrap>
      </GridWrap>
    </>
  );
};

export { Accordion11CommentiPerReport };
